import React from 'react'
import Input from 'components/Input'
import { withTranslation } from 'react-i18next'


export default withTranslation()(function RoleManagement({t}) {

  const fields = [
    {
      name: 'name',
      label: t('settings.role_management.name.name'),
      placeholder: t('settings.role_management.name.label')
    },
    {
      name: 'display_name',
      label: t('settings.role_management.display_name.name'),
      placeholder: t('settings.role_management.display_name.name')
    }
  ]


  return (
    <>
      {
        fields.map((field, index) => {
          return (
            <div className="mb-5" key={`${ index }_`}>
              <Input 
                name={field.name}
                label={field.label}
                placeholder={field?.placeholder}
                variant="filled"
                // labelwithin={true}
              />
            </div>
          )
        })
      }
    </>
  )
})